interface TabButtonProps {
  icon?: React.ReactNode
  label: string
  isActive: boolean
  onClick: () => void
  variant?: 'underline' | 'container' | 'simple'
  className?: string
}

function TabButton({
  icon,
  label,
  isActive,
  onClick,
  variant = 'underline',
  className = ''
}: TabButtonProps) {
  const getClassName = () => {
    if (variant === 'simple') {
      // New simple variant matching design - clean underline style
      return `px-8 py-4 font-medium transition-colors flex items-center justify-center gap-3 border-b-2 ${
        isActive
          ? 'text-fx-text-dark border-fx-text-dark'
          : 'text-fx-text-muted border-transparent hover:text-gray-700'
      } ${className}`
    }

    if (variant === 'container') {
      return `px-6 py-3 font-medium transition-colors flex items-center justify-center rounded-lg ${
        isActive
          ? 'bg-white text-gray-900'
          : 'text-gray-600 hover:text-gray-900'
      } ${className}`
    }

    // Default underline variant
    return `flex-1 px-6 py-3 font-medium transition-colors flex items-center justify-center ${
      isActive
        ? 'text-blue-600 border-b-2 border-blue-600'
        : 'text-gray-600 hover:text-gray-900'
    } ${className}`
  }

  return (
    <button onClick={onClick} className={getClassName()}>
      {icon && <span className={variant === 'simple' ? 'text-xl' : 'mr-2'}>{icon}</span>}
      <span className={variant === 'simple' ? 'text-base' : ''}>{label}</span>
    </button>
  )
}

export default TabButton
